import "./TocAvailabilityNotice.css";
import { Alert, Button, Container } from "reactstrap";
import { faKey, faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header from "../Header";
import { useTranslation } from "react-i18next";

interface Props {
  logout: () => void;
}

export function AuthFailedNotice(props: Props) {
  const { t } = useTranslation();

  return (
    <Container fluid>
      <Header />
      <br />
      <Alert color="danger" fade={false}>
        <h2 className={"light-header"}>
          <FontAwesomeIcon icon={faKey} /> {t("auth.loginFailedTitle")}
        </h2>
        <br />
        {t("auth.loginFailedDesc")}
        <br />
        <br />

        <Button color="primary" onClick={() => props.logout()} className="me-2">
          <FontAwesomeIcon icon={faLock} /> {t("auth.logout")}
        </Button>
      </Alert>
    </Container>
  );
}
